<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-row.mb-2
      b-col.page-wrap(cols="12")
        div.page-header(slot="header")
          b-container.d-flex.justify-content-between(fluid)
            span.page-title {{$t('management_page.remote_device_integration_management')}}

    b-row.search-form
      b-col.mmb-10(cols="12" lg="5")
        b-input-group
          b-input-group-prepend
            b-form-select.mr-2(v-model="form.search_key" :options="selectOptions.list" size="sm" @change="changeSearchSelect")
          b-form-input.mr-2(v-if="selectInput.type === 'keyword'" v-model="form.search_value" size="sm" @keyup.enter="search")
          b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="form.search_value" :options="selectInput.list" size="sm")
          b-input-group-append
            b-btn(size="sm" @click="search") {{$t('search')}}

      b-col.right-btns
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...
        b-btn.ml-2(size="sm" variant="primary" @click="selectDelete(allChecked)") {{$t('select_delete')}}
    
    b-card.table-card
      b-table(
        ref="agentTable"
        :fields="tableData.fields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        :empty-text="$t('no-content')"
        tbody-class="lmm-table-body"
        sort-by="create_time"
        :sort-desc="true"
        show-empty
        responsive
      )
        //- header
        template(v-slot:head(check)="row")
          b-form-checkbox(v-model="allSelected" @input="selectAllRows")

        //- body
        template(v-slot:cell(check)="row")
          b-form-checkbox(v-model="row.item.isSelected" @change="handleCheck(row.item)")

        template(v-slot:cell(create_time)="row")
          span {{ row.item.create_time | moment('YY-MM-DD HH:mm') }}

        template(v-slot:cell(user_id)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.user_id}}

        template(v-slot:cell(user_name)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.user_name}}

        template(v-slot:cell(part_name)="row")
          b-btn(variant="link", :to="{name: 'user-edit-department', params: {id: row.item.part_pk}}") {{row.item.part_name}}
        
        template(v-slot:cell(status)="row")
          img(v-if="row.item.status" :src="`${AppState.Path.image}/icons/status_online.svg`")
          img(v-else :src="`${AppState.Path.image}/icons/status_offline.svg`")
          span(:style="`${row.item.status ? 'color: #1D8102' : '' }`") &nbsp;{{ stateFilter(row.item.status) }}
        
        template(v-slot:cell(flag_auto_record)="row")
          switches(
            v-model="row.item.flag_auto_record",
            theme="bootstrap",
            :color="row.item.flag_auto_record ? 'warning' : 'default'",
            :emitOnMount="false",
            @input="changeRecord(row.item)"
          )

        template(v-slot:cell(approval_name)="row")
          b-btn(variant="link" @click="openDialogApprovalLineInfo(row.item)") {{row.item.approval_name}}

        template(v-slot:cell(btn)="row")
          b-button.d-inline-flex(size="sm" variant="primary" @click="selectDelete([row.item])") 삭제
        
        template(v-slot:cell(cs_ver)="row")
          span {{ row.item.cs_ver[0] }}

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="tableData.pagination.limit"
          :options="tableData.pagination.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="tableData.pagination.current"
        :total-rows="tableData.pagination.total"
        :per-page="tableData.pagination.limit"
        class="my-0 float-right"
      )

    confirm-dialogs(:show.sync="showAgentDelete" :option="{ size: 'md', title: this.$t('delete_registered_remote_device') }")
      .warning
        icon.icon(name="exclamation-triangle" width="50" height="50")
        span ※ Warning ※
      .msg {{$t('confirm_delete_registered_device')}}
      .box
        .select
          span(v-for="item of deleteList" :key="item.pk") {{$t('remote_device')}}({{ item.device_name }})
        .msg(v-html="$t('management_page.re_registration_requirements')")
      .bottom-btns
        b-btn(size="sm" variant="danger" @click="deleteAgent" pill) {{$t('delete')}}
        b-btn.btn-secondary(size="sm" @click="showAgentDelete = false" pill) {{$t('cancel')}}

    dialog-approval-line-info(:show.sync="showDialogApprovalLineInfo" :form="approvalLineForm")
</template>

<script>
import { ManagementAPI, UserEntityRegisterAPI, GetMgridAPI } from "@/api"
import ConfirmDialogs from "@/components/mixins/dialog/confirm.vue"
import DialogApprovalLineInfo from "../components/dialogApprovalLineInfo.vue"
import _ from "lodash"
import moment from "moment"
import Switches from "vue-switches"

export default {
  components: {
    ConfirmDialogs,
    Switches,
    DialogApprovalLineInfo,
  },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.form.search_key })
    },
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    stateFilter() {
      return value => {
        return value ? this.$t('icon_online') : this.$t('icon_offline')
      }
    },
  },
  data() {
    return {
      range: {
        start: moment()
          .add(-14, "days")
          .toDate(),
        end: moment().toDate(),
      },

      form: {
        search_key: "user_id",
        search_value: "",
      },
      selectOptions: {
        list: [
          { text: this.$t('ID'), value: "user_id", type: "keyword" },
          { text: this.$t('account-manage'), value: "user_name", type: "keyword" },
          { text: this.$t('department'), value: "part_name", type: "keyword" },
          { text: this.$t('remote_device'), value: "device_name", type: "keyword" },
          {
            text: "OS",
            value: "user_os",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              // { text: "UNKNOWN", value: "0" },
              { text: "Windows", value: "1" },
              // { text: "Linux", value: "2" },
              // { text: "OS_X", value: "3" },
              // { text: "Android", value: "4" },
              // { text: "iOS", value: "5" },
            ],
          },
          {
            text: this.$t('status'),
            value: "status",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: this.$t('icon_online'), value: "1" },
              { text: this.$t('icon_offline'), value: "0" },
            ],
          },
          { text: this.$t('memo'), value: "memo", type: "keyword" },
          { text: "IP", value: "s_pub_ip", type: "keyword" },
          {
            text: this.$t('recording'),
            value: "flag_auto_record",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: "O", value: "1" },
              { text: "X", value: "0" },
            ],
          },
          { text: this.$t('management_page.final_approver'), value: "approval_name", type: "keyword" },
          { text: this.$t('version'), value: "cs_ver", type: "keyword" },
        ],
      },
      excelLoaded: false,
      excelLink: null,

      allSelected: false,
      allChecked: [],
      tableData: {
        fields: [
          {
            key: "check",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: false,
            thStyle: { width: "1%" },
          },
          { key: "user_id", label: this.$t('ID'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
          { key: "user_name", label: this.$t('account-manage'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
          { key: "part_name", label: this.$t('department'), sortable: true, thStyle: { minWidth: "100px" }, tdClass: "text-nowrap" },
          { key: "create_time", label: this.$t('registration_datetime'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
          { key: "device_name", label: this.$t('remote_device'), sortable: true, thStyle: { minWidth: "150px" }, tdClass: "text-nowrap" },
          { key: "user_os", label: "OS", sortable: true, thStyle: { minWidth: "100px" }, tdClass: "text-nowrap" },
          { key: "status", label: this.$t('status'), sortable: true, thStyle: { minWidth: "100px" }, tdClass: "text-nowrap" },
          { key: "memo", label: this.$t('memo'), sortable: true, thStyle: { minWidth: "150px" }, tdClass: "text-nowrap" },
          { key: "s_pub_ip", label: "IP", sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "flag_auto_record", label: this.$t('recording'), sortable: true, thStyle: { minWidth: "70px" }, tdClass: "text-nowrap" },
          { key: "approval_name", label: this.$t('management_page.final_approver'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
          { key: "cs_ver", label: this.$t('version'), sortable: true, thStyle: { minWidth: "80px" }, tdClass: "text-nowrap" },
          { key: "btn", label: this.$t('delete'), thClass: "text-center", thStyle: { minWidth: "70px" }, tdClass: "text-nowrap text-center" },
        ],
        list: [],
        pagination: {
          by: "create_time",
          limit: 24,
          offset: 0,
          order: "desc",

          reqeust_type: 0,

          search_key: "",
          search_value: "",
          search_mode: "pagination",

          total: 1,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },

      showAgentDelete: false,
      deleteList: [],

      showDialogApprovalLineInfo: false,
      approvalLineForm: {
        type: 1,
        type_pk: null,
      },
    }
  },
  methods: {
    fetchList(ctx) {
      if (ctx.sortBy === "") return

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,

        request_type: this.tableData.pagination.reqeust_type,

        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      return ManagementAPI.management.get("agent", { params }).then(res => {
        const { objects, meta, status } = res.data
        if (status !== 200) {
          this.$awn.warning(this.$t('toasts_message.data_fetch_failed'))
          return []
        }

        this.tableData.list = objects
        this.tableData.pagination.total = meta.total_count

        return this.tableData.list
      })
    },
    openDialogApprovalLineInfo(item) {
      this.approvalLineForm.type_pk = item.type_pk
      this.showDialogApprovalLineInfo = true
    },
    search() {
      this.tableData.pagination.current = 1
      this.tableData.pagination.search_key = this.form.search_key
      this.tableData.pagination.search_value = this.form.search_value
      this.$refs.agentTable.refresh()
    },

    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(this.$t('toasts_message.no_data_to_download_excel'))
          return
        })
    },

    async fetchExcel() {
      let params = {
        by: this.tableData.pagination.by,
        limit: 0,
        offset: 0,
        order: this.tableData.pagination.order,

        request_type: this.tableData.pagination.reqeust_type,

        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      if (this.tableData.pagination.total < 1) {
        throw new Error(String(this.$t('no_data_available')))
      }
      const list = await ManagementAPI.management.get("agent", { params })

      const excelParams = list.data
      excelParams.excel_doc_title = this.$t('management_page.remote_device_integration_management')
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "agent_integrated"
      excelParams_for_download.excel_doc_title = this.$t('management_page.remote_device_integration_management')

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input은 excelParams.objects
      let status = {
        true: this.$t('icon_online'),
        false: this.$t('icon_offline'),
      }
      let flag_auto_record = {
        "1": "O",
        "0": "X",
      }
      let output = []
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('ID')]: input[index]["user_id"],
          [this.$t('account-manage')]: input[index]["user_name"],
          [this.$t('department')]: input[index]["part_name"],
          [this.$t('management_page.registration_date')]: this.Date_time_split(input[index]["proposal_time"])[0],
          [this.$t('management_page.registration_time')]: this.Date_time_split(input[index]["proposal_time"])[1],
          [this.$t('remote_device')]: input[index]["device_name"],
          OS: input[index]["user_os"],
          [this.$t('status')]: status[input[index]["status"]],
          [this.$t('memo')]: this.nullcheck(input[index]["memo"]),
          IP: input[index]["s_pub_ip"],
          [this.$t('recording')]: flag_auto_record[input[index]["flag_auto_record"]],
          [this.$t('management_page.final_approver')]: input[index]["approval_name"],
          [this.$t('version')]: input[index]["cs_ver"][0],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },
    handleCheck(item) {
      if (this.allChecked.includes(item)) {
        const index = this.allChecked.findIndex(u => u.pk === item.pk)
        this.allChecked.splice(index, 1)
      }
      if (item.isSelected) {
        this.allChecked.push(item)
      }
    },
    selectAllRows() {
      _.each(this.tableData.list, v => {
        v.isSelected = this.allSelected
        this.handleCheck(v)
      })
    },

    selectDelete(items) {
      if (items.length === 0) {
        this.$bvToast.toast(this.$t('management_page.no_selected_department_members'), {
          title: "Warning",
          variant: "warning",
          solid: true,
        })
        return
      }
      this.deleteList = _.cloneDeep(items)
      this.showAgentDelete = true
    },

    changeSearchSelect() {
      if (this.selectInput.type === "select") {
        this.form.value = this.selectInput.list[0].value
      } else {
        this.form.value = ""
      }
    },

    changeRecord(item) {
      const params = {
        pk: item.pk,
        flag_auto_record: item.flag_auto_record ? 1 : 0,
      }
      ManagementAPI.management.put("agent", params)
    },

    async deleteAgent() {
      let result = true
      for (const item of this.deleteList) {
        const data = {
          input_type: "agent",
          device_id: item.device_id,
        }
        await UserEntityRegisterAPI.delete(String(item.user_fk), { data }).catch(err => {
          result = false
        })
      }
      if (result) {
        this.$bvToast.toast(this.$t('toasts_message.remote_device_deleted'), {
          title: this.$t('success'),
          variant: "success",
          solid: true,
        })
        this.showAgentDelete = false
        this.$refs.agentTable.refresh()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-link {
  padding: 0.41rem 0.75rem 0.41rem 0;
  font-size: 14px;
}

.btn-secondary {
  color: #6f6f6f;
  border-color: #6f6f6f;
  background-color: #fff;
  text-align: center;
}
</style>